import { useBundlesForOrg } from './useBundlesForOrg'
import { useSelectedOrgOrThrow } from '../../../../components'

export const useBundlesForSelectedOrg = () => {
  const selectedOrg = useSelectedOrgOrThrow()
  return useBundlesForOrg(selectedOrg._id)
}
